import { RuleId } from '@wix/a11y-rules';
import { useCallback } from 'react';
import { BiCtaNames, BiModalTypes, BiScreenTypes } from '../../../bi/types';
import { SITE_LEVEL_PAGE_ID } from '../../../consts';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useReorganizePagesDOMOrder } from './use-reorganize-pages-dom-order';
export const useDomOrderOnApply = _ref => {
  let {
    setIsApplyTriggered,
    setRuleApplyTriggered
  } = _ref;
  const {
    reorganizePagesDOMOrder
  } = useReorganizePagesDOMOrder();
  const biLogger = useBiLogger();
  const getOnApply = useCallback(_ref2 => {
    let {
      isManuallyCompleted,
      updateRuleState,
      uiStatus
    } = _ref2;
    const handleCancel = () => biLogger.modalCtaClick({
      ctaName: BiCtaNames.Cancel,
      modalType: BiModalTypes.UnableToOrganizeDOMOrder
    });
    const handleTryAgain = async fixOption => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.TryAgain,
        modalType: BiModalTypes.UnableToOrganizeDOMOrder
      });
      if (fixOption) {
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.Apply,
          index: 0,
          status: uiStatus
        });
        await reorganizePagesDOMOrder({
          fixOption,
          handleCancel,
          handleTryAgain,
          isManuallyCompleted,
          screenType: BiScreenTypes.DetectedIssues
        });
      }
    };
    const applyFunc = async fixOption => {
      biLogger.taskElementCtaClick({
        ctaName: BiCtaNames.Apply,
        index: 0,
        status: uiStatus
      });
      await reorganizePagesDOMOrder({
        fixOption,
        handleCancel,
        handleTryAgain,
        isManuallyCompleted,
        screenType: BiScreenTypes.DetectedIssues
      });
      updateRuleState(fixOption);
      setIsApplyTriggered(true);
      setRuleApplyTriggered({
        pageId: SITE_LEVEL_PAGE_ID,
        ruleId: RuleId.DOM_ORDER
      });
    };
    return applyFunc;
  }, [setIsApplyTriggered, setRuleApplyTriggered, biLogger, reorganizePagesDOMOrder]);
  return {
    getOnApply
  };
};
//# sourceMappingURL=use-dom-order-on-apply.js.map